module.exports = __webpack_public_path__ + "static/img/punto_6.870fe48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/punto_6.jpg
// module id = exh6
// module chunks = 2